import { Sparkles, Truck, ShieldCheck } from "lucide-react";

export const PromoBanner = () => {
  return (
    <section
      data-testid="promo-banner"
      className="relative overflow-hidden bg-gradient-to-r from-cyan-600 via-cyan-500 to-teal-500 text-white"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-10 -left-10 w-72 h-72 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute -bottom-10 right-1/4 w-80 h-80 rounded-full bg-cyan-300/20 blur-3xl" />
      </div>
      <div className="relative max-w-7xl mx-auto px-5 md:px-10 py-3 md:py-3.5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-center text-sm font-semibold">
        <span className="inline-flex items-center gap-2">
          <Sparkles className="w-4 h-4" />
          Super ofertă · Transport gratuit la pachete XXL
        </span>
        <span className="hidden sm:inline opacity-50">•</span>
        <span className="inline-flex items-center gap-2">
          <Truck className="w-4 h-4" />
          Livrare 24-48h în toată România
        </span>
        <span className="hidden md:inline opacity-50">•</span>
        <span className="hidden md:inline-flex items-center gap-2">
          <ShieldCheck className="w-4 h-4" />
          Plată cash la livrare
        </span>
      </div>
    </section>
  );
};
